<template>
  <!-- 客户/供应商管理视图 -->
  <a-modal
    :title="titleStr"
    :visible="isVisible"
    :dialog-style="{ top: '0' }"
    :bodyStyle="{ padding: '0', backgroundColor: '#f3f3f4' }"
    :destroyOnClose="true"
    :maskClosable="false"
    width="100%"
    @cancel="close"
    :footer="null"
    class="customerDetailsStyle"
  >
    <div class="projectDetail">
      <div class="information">
        <a-affix :offset-top="0">
          <div class="inform">
            <div class="titleContent">
              <div style="margin-bottom: 10px;">
                <b style="font-size: 18px;">{{dataValue.companyName}}</b>
                <!-- <p class="labelCon">
              <span class="title">{{ dataValue.contractTitle }}</span>
              <span v-if="dataValue.contractState === 0" class="stage s1">执行中</span>
              <span v-if="dataValue.contractState === 1" class="stage s2">结束</span>
              <span v-if="dataValue.contractState === 2" class="stage s3">意外中止</span>
                </p>-->
              </div>
              <div class="label">
                <span class="labelCOlor">数据所有人：</span>
                <p class="labelCon">
                  <span style="color: #333;">{{ dataValue.creator }}</span>
                </p>
              </div>
              <div style="display: flex;">
                <a-button
                  v-if="nowUserName === dataValue.creator && isShowEdit"
                  type="primary"
                  icon="edit"
                  class="filter-item add-but"
                  @click="editClick"
                >编辑</a-button>
                <span v-else>
                  <a-button
                    v-if="isShowEdit"
                    v-hasPermission="'customer:update'"
                    type="primary"
                    icon="edit"
                    class="filter-item add-but"
                    @click="editClick"
                  >编辑</a-button>
                </span>
                <a-button
                  v-hasPermission="'log:view'"
                  type="primary"
                  icon="eye"
                  class="filter-item add-but"
                  style="margin-left: 10px;"
                  @click="logClick"
                >日志</a-button>
              </div>
            </div>
            <div class="moneyStyle">
              <div v-for="(item, index) in moneyList" :key="index" style="margin-right:24px;">
                <a-tooltip placement="top">
                  <template slot="title" v-if="item.tip">
                    <span>{{ item.tip }}</span>
                  </template>
                  <span class="stage" :style="{'backgroundColor': item.colorVal}">{{item.name}}</span>
                </a-tooltip>
                <!-- <span class="stage" :style="{'backgroundColor': item.colorVal}">{{item.name}}</span> -->
                <a-tooltip placement="bottomLeft">
                  <template slot="title">
                    <span>{{ item.value || 0 }}</span>
                  </template>
                  <div class="amountNum" :style="{'color': item.colorVal}">
                    <span class="sign">¥</span>
                    <span class="first">{{ formatAmount(item.value) }}</span>
                    <!-- <span class="first">{{amountVal(item.value).first}}</span>
                    <span class="last">{{ amountVal(item.value).last && amountVal(item.value).last !== '万' ? '.' : '' }}{{ amountVal(item.value).last }}</span>-->
                  </div>
                </a-tooltip>
              </div>
            </div>
            <div class="more">
              <a-row>
                <a-col>
                  <a-button type="primary" icon="bar-chart" @click="clickMore">更多</a-button>
                </a-col>
              </a-row>
            </div>
          </div>
        </a-affix>
      </div>
      <div class="content_line1">
        <div class="leftDiv" style="display:inline-block;">
          <div style="display: flex;" class="leftTitle">
            <div style="width: 150px">
              <span>附件上传</span>
            </div>
            <!-- <attachmentUpload
              ref="uploadRef"
              :val-name="valName"
              @uploadChange="uploadChange"
              style="text-align: right"
            />-->
          </div>
          <div class="leftContent" v-if="isShowFile">
            <upload-attachment
              ref="uploadRef"
              :val-name="valName"
              @uploadChange="uploadChange"
              @delSucc="fileDelSucc"
            />
          </div>
        </div>
        <div style="width: 58%;float:right;margin: 10px 20px 0 0;">
          <div class="timeline">
            <TimeLine
              ref="timelineRef"
              :emtyTitle="emtyTitle"
              :emtyTime="emtyTime"
              @invoiceListChange="invoiceListChange"
            />
          </div>
        </div>
        <div class="leftDiv">
          <div class="leftTitle">公司基本信息</div>
          <div class="leftContent">
            <ul v-if="dataValue.type === 1" style="padding: 0 20px;">
              <li>
                编号：
                <span class="li_content">{{dataValue.customerCode}}</span>
              </li>
              <li>
                种类：
                <span class="li_content">{{getName(dataValue.customerType)}}</span>
              </li>
              <li>
                客户名称：
                <span class="li_content">{{dataValue.companyName}}</span>
              </li>
              <li>
                联系人姓名：
                <span class="li_content">{{dataValue.name}}</span>
              </li>
              <li>
                手机号码：
                <span class="li_content">{{dataValue.phone}}</span>
              </li>
              <li>
                上级客户/供应商：
                <span class="li_content">{{dataValue.upperCustomerName}}</span>
              </li>
              <li>
                收款人名称：
                <span class="li_content">{{dataValue.payeeName}}</span>
              </li>
              <li>
                银行账号：
                <span class="li_content">{{dataValue.bankAccount}}</span>
              </li>
              <li>
                银行名称：
                <span class="li_content">{{dataValue.bankName}}</span>
              </li>
              <li>
                所属员工：
                <span class="li_content">{{dataValue.creator}}</span>
              </li>
              <li>
                创建时间：
                <span class="li_content">{{dataValue.createTime}}</span>
              </li>
            </ul>
            <ul v-else-if="dataValue.type === 2" style="padding: 0 20px;">
              <li>
                种类：
                <span class="li_content">{{getName(dataValue.customerType)}}</span>
              </li>
              <li>
                供应商名称：
                <span class="li_content">{{dataValue.companyName}}</span>
              </li>
              <li>
                联系人：
                <span class="li_content">{{dataValue.name}}</span>
              </li>
              <li>
                联系方式：
                <span class="li_content">{{dataValue.phone}}</span>
              </li>
              <li>
                收款人名称：
                <span class="li_content">{{dataValue.payeeName}}</span>
              </li>
              <li>
                银行账号：
                <span class="li_content">{{dataValue.bankAccount}}</span>
              </li>
              <li>
                银行名称：
                <span class="li_content">{{dataValue.bankName}}</span>
              </li>
              <li>
                行号：
                <span class="li_content">{{dataValue.bankCode}}</span>
              </li>
              <li>
                付款信息：
                <span class="li_content">{{dataValue.payInfo}}</span>
              </li>
              <li>
                所属员工：
                <span class="li_content">{{dataValue.creator}}</span>
              </li>
              <li>
                创建时间：
                <span class="li_content">{{dataValue.createTime}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <message ref="messageRef" :dialogVisible="moreVisible" @close="moreVisible = false" />
    <add-edit
      ref="addEditRef"
      :title="addTitle"
      :dialog-visible="addVisible"
      @success="addSuccess"
      @close="addClose"
    />
    <addEditValue
      ref="addEditRefed"
      :title="addTitleed"
      :dialog-visible="addVisibleed"
      @success="addSuccessed"
      @close="addCloseed"
    />
    <note-add-vue
      ref="noteAddRef"
      :title="`[新建]${this.$tree([], 'purchase/purchaseNote/index')}`"
      :dialog-visible="noteAddVisible"
      @success="noteAddSucc"
      @close="noteAddClose"
    />
    <addEditView
      ref="addEditView"
      :title="moduleTitle"
      :client-type="clientType"
      :dialog-visible="addEditViewVisible"
      @success="addEditSuccess"
      @close="addEditClose"
    />
    <addEditViews
      ref="addEditViews"
      :title="moduleTitle"
      :customer-type="customerType"
      :dialog-visible="addEditViewVisibles"
      @success="addEditSuccess"
      @close="addEditClose"
    />
    <public-log-dialog
      :title="publicLogDias.title"
      ref="publicLogDiasRef"
      :dialog-visible="publicLogDias.visible"
      @logSuccess="publicLogDiasSucc"
      @cancel="publicLogDiasCancel"
    ></public-log-dialog>
  </a-modal>
</template>

<script>
import { removeZero } from '@/utils'
import uploadAttachment from '@/views/common/Upload.vue'
import TimeLine from '@/views/common/TimeLine.vue'
import message from './message'
import { formatAmount } from '@/utils/common'
import addEdit from '../financialManage/billingRecords/addEdit.vue'
import addEditValue from '../financialManage/ticketReceiptRecord/addEdit.vue'
import addEditViews from '../purchase/supplier/addEdit.vue'
import addEditView from './addEdit.vue'
import noteAddVue from '../purchase/purchaseNote/addEdit.vue'
import attachmentUpload from '../common/attachmentUpload.vue'
import publicLogDialog from '@/components/modelDialog/publicLogDialog.vue'
export default {
  name: 'ProjectDetail',
  props: {
    isShowEdit: {
      type: Boolean,
      default: true
    },
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  components: { uploadAttachment, TimeLine, message, addEdit, addEditValue, noteAddVue, attachmentUpload, addEditView, addEditViews, publicLogDialog },
  provide () {
    return {
      formData: this
    }
  },
  mounted () {
    this.$emit('onClickView')
    this.clientType = this.$store.state.account.dictData.customerTypeList
  },
  computed: {
    isVisible: {
      get () {
        return this.dialogVisible
      },
      set () {
        this.close()
      }
    },
    systemColor () {
      return this.$store.state.setting.color[0]
    },
    followDataNum () {
      var data = this.allFollowData
      var obj = {
        all: data.prePaymentNum + data.purchaseRequisitionNum + data.reimbursementNum || 0,
        prePaymentNum: data.prePaymentNum || 0,
        purchaseRequisitionNum: data.purchaseRequisitionNum || 0,
        reimbursementNum: data.reimbursementNum || 0
      }
      return obj
    }
  },
  data () {
    return {
      nowUserName: this.$db.get('USER').username,
      publicLogDias: {
        title: '',
        visible: false
      },
      isShowFile: true,
      moduleTitle: '',
      addEditViewVisible: false,
      addEditViewVisibles: false,
      clientType: [],
      titleStr: '客户视图',
      emtyTitle: false,
      emtyTime: true,
      addTitle: '',
      addVisible: false,
      noteAddVisible: false,
      addTitleed: '',
      uploadFileList: [],
      valName: 'uploadFileList',
      addVisibleed: false,
      dataValue: {},
      followData: {},
      customerId: '',
      allFollowData: {},
      tabIndex: '-1',
      pagination: {
        pageSize: 10,
        pageNum: 1
      },
      moneyList: [],
      // 客户视图统计
      customerList: [
        {
          name: '合同单金额',
          value: 0,
          colorVal: '#1C84C6'
        },
        {
          name: '未回款金额',
          value: 0,
          colorVal: '#ED5565'
        },
        {
          name: '已回款金额',
          value: 0,
          colorVal: '#1AB394'
        },
        {
          name: '已开票金额',
          value: 0,
          colorVal: '#20d3d3'
        }
      ],
      // 供应商视图统计
      supplierList: [
        {
          name: '采购总金额',
          value: 0,
          colorVal: '#1C84C6'
        },
        {
          name: '实际金额',
          value: 0,
          colorVal: '#42b983',
          tip: '实际金额 = 采购金额 - 退款金额 - 其他项目摊销'
        },
        {
          name: '退款金额',
          value: 0,
          colorVal: '#1AB394'
        },
        {
          name: '采购未付款金额',
          value: 0,
          colorVal: '#ED5565'
        },
        {
          name: '采购已付款金额',
          value: 0,
          colorVal: '#1AB394'
        },
        {
          name: '付款收票金额',
          value: 0,
          colorVal: '#20d3d3'
        }
      ],
      customerType: this.$store.state.account.dictData.supplierTypeList,
      customerTypeObj: this.$store.state.account.dictData.customerTypeObj, // 客户类型
      supplierTypeObj: this.$store.state.account.dictData.supplierTypeObj, // 供应商类型
      moreVisible: false
    }
  },
  methods: {
    formatAmount,
    fileDelSucc (e) { // 附件删除成功-调用修改接口
      let fileArr = this.dataValue.fileIds.split(',')
      let newFileArr = fileArr.filter(item => item !== e)
      this.$set(this.dataValue, 'fileIds', newFileArr.join(','))
      this.uploadFileList = newFileArr.join(',')
      this.$post('/customer/update', this.dataValue).then(res => {
        if (res.status === 200 && res.data.status === 1) {
          this.initData(this.dataValue, this.dataValue.id)
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    editClick () {
      if (this.dataValue.type === 1) {
        this.moduleTitle = `[修改]${this.$tree([], 'customerManage/index')}`
        this.addEditViewVisible = true
        this.$refs.addEditView.setForm(this.dataValue)
      } else {
        this.moduleTitle = `[修改]${this.$tree([], 'purchase/supplier/index')}`
        this.addEditViewVisibles = true
        this.$refs.addEditViews.initData(this.dataValue)
      }
    },
    logClick () {
      this.publicLogDias.visible = true
      this.publicLogDias.title = '数据操作日志'
      let params = {}
      if (this.dataValue.type === 1) { // 客户
        params = {
          serviceType: 'customer',
          serviceId: `${this.dataValue.id}`
        }
      } else { // 供应商
        params = {
          serviceType: 'customer',
          serviceId: `${this.dataValue.id}`
        }
      }
      this.$refs.publicLogDiasRef.getLog(params)
    },
    publicLogDiasCancel () {
      this.publicLogDias.visible = false
    },
    publicLogDiasSucc () {
      this.publicLogDias.visible = false
    },
    addEditSuccess () {
      this.addEditViewVisible = false
      this.addEditViewVisibles = false
      this.initData(this.dataValue, this.dataValue.id)
    },
    addEditClose () {
      this.addEditViewVisible = false
      this.addEditViewVisibles = false
    },
    getName (val) {
      if (this.dataValue.type === 1) {
        // 客户
        return this.customerTypeObj[val]
      } else if (this.dataValue.type === 2) {
        // 供应商
        return this.supplierTypeObj[val]
      }
    },
    initData (row, customerId, type) {
      this.customerId = customerId
      // 根据id查询客户详情
      this.$get('/customer/getById', { id: customerId }).then(res => {
        if (res.data.status === 1) {
          if (Object.keys(res.data.data).length !== 0) {
            this.dataValue = res.data.data
            if (this.dataValue.type === 2) {
              this.titleStr = '供应商视图'
              this.moneyList = this.supplierList
            } else {
              this.titleStr = '客户视图'
              this.moneyList = this.customerList
            }
            this.$nextTick(() => {
              // 获取跟单时间线
              this.$get('/follow', { followType: 3, id: customerId, customerType: this.dataValue.type }).then(res => {
                if (res.data.status === 1) {
                  this.followData = res.data.data
                  if (this.titleStr === '客户视图') {
                    this.moneyList[0].value = res.data.data.topInfo1st
                    this.moneyList[1].value = res.data.data.topInfo2nd
                    this.moneyList[2].value = res.data.data.topInfo3rd
                    this.moneyList[3].value = res.data.data.topInfo4th
                  } else {
                    this.moneyList[0].value = res.data.data.topInfo1st
                    this.moneyList[1].value = res.data.data.actualMoney
                    this.moneyList[2].value = res.data.data.payRefundMoney
                    this.moneyList[3].value = res.data.data.topInfo2nd
                    this.moneyList[4].value = res.data.data.topInfo3rd
                    this.moneyList[5].value = res.data.data.topInfo4th
                  }
                  this.$nextTick(() => {
                    this.$refs.timelineRef.getFollow(res.data.data, 3, customerId, this.dataValue.type)
                  })
                } else {
                  this.$message.error(res.data.message)
                }
              })
            })
            if (!type) {
              // 根据id查询详情
              if (this.dataValue.fileIds) { // string 转 数组  循环获取附件信息
                let fileList = this.dataValue.fileIds.split(',')
                this.$nextTick(() => {
                  this.$refs.uploadRef.getFile(fileList)
                })
              }
            }
          } else {
            this.$message.warning('未查询到该数据，可能已删除或者没有操作权限，请检查！', 5)
          }
        }
      })
    },
    amountVal (itemVal) {
      var money = this.formatNumber(itemVal)
      var arrObj = {
        first: '',
        last: ''
      }
      if (money.includes('.')) {
        var arr = money.split('.')
        arrObj.first = arr[0] ? arr[0] : arr[1]
        arrObj.last = arr[0] ? arr[1] : ''
      } else {
        arrObj.first = money.slice(0, -1)
        arrObj.last = money.slice(-1)
      }
      return arrObj
    },
    // 点击详细
    clickMore () {
      this.moreVisible = true
      this.$nextTick(() => {
        this.$refs.messageRef.setData(this.dataValue.type, this.followData)
      })
    },
    changeTime (e) {
      this.tabIndex = e
      this.pagination.pageNum = 1
    },
    invoiceListChange (item, value) {
      // console.log('item, value =>', item, value)
      if (value === 'b') {
        this.addTitle = `[新建]-${this.$tree([], 'financialManage/billingRecords/index')}`
        this.addVisible = true
        this.$refs.addEditRef.setForm(item, 1)
      } else if (value === 'a') {
        this.addTitleed = `[新建]-${this.$tree([], 'financialManage/ticketReceiptRecord/index')}`
        this.addVisibleed = true
        this.$refs.addEditRefed.setForm(item, 1)
      } else if (value === 'c') {
        this.noteAddVisible = true
        this.$nextTick(() => {
          this.$refs.noteAddRef.setNoteData(item)
        })
      } else {
        this.initData('1111', this.customerId)
      }
    },
    addSuccess () {
      this.addVisible = false
      this.initData('1111', this.customerId)
      // this.initDataes(this.ids)
      // this.$refs.invoiceListVue.initData()
    },
    addClose () {
      this.addVisible = false
      this.initData('1111', this.customerId)
      // this.initDataes(this.ids)
      // this.$refs.invoiceListVue.initData()
    },
    addSuccessed () {
      this.addVisibleed = false
      this.initData('1111', this.customerId)
      // this.initDataes(this.ids)
      // this.$refs.invoiceListVue.initData()
    },
    addCloseed () {
      this.addVisibleed = false
      this.initData('1111', this.customerId)
      // this.initDataes(this.ids)
      // this.$refs.invoiceListVue.initData()
    },
    uploadChange (e) {
      // if (this.dataValue.fileIds) {
      //   this.dataValue.fileIds = this.dataValue.fileIds.split(',')
      // } else if (this.dataValue.fileIds === null || this.dataValue.fileIds === '') {
      //   this.dataValue.fileIds = []
      // }
      const fileIds = Array.isArray(this.uploadFileList)
        ? (this.uploadFileList.length ? this.uploadFileList : [])
        : (this.uploadFileList ? this.uploadFileList.split(',').filter(Boolean) : [])
      const currentFileIds = Array.isArray(this.dataValue.fileIds) ? this.dataValue.fileIds : (this.dataValue.fileIds ? this.dataValue.fileIds.split(',') : [])
      const mergedIds = [...new Set([...currentFileIds, ...fileIds])] // 合并并去重
      this.$set(this.dataValue, 'fileIds', mergedIds)
      this.dataValue.fileIds.push(e[e.length - 1].id)
      this.isShowFile = false
      this.dataValue.fileIds.push(e[0].id)
      this.dataValue.fileIds = this.dataValue.fileIds.join(',')
      this.$post('/customer/update', this.dataValue).then(res => {
        if (res.data.status === 1) {
          // this.$message.success(res.data.message)
          this.isShowFile = true
          this.$nextTick(() => {
            this.$refs.uploadRef.getFile(this.dataValue.fileIds.split(','))
          })
          this.$emit('success')
          // this.initData(this.dataValue, this.dataValue.id, 1)
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    noteAddSucc () {
      // this.initDataes(this.ids)
      this.initData('1111', this.customerId)
      this.noteAddVisible = false
      // 采购单新增成功后 隐藏查看采购申请、刷新页面数据
      // this.drawerVisible = false
      // this.initData()
    },
    noteAddClose () {
      this.initData('1111', this.customerId)
      // this.initDataes(this.ids)
      this.noteAddVisible = false
    },
    close () {
      this.$emit('close')
      this.emtyTitle = false
      this.emtyTime = true
    },
    formatNumber (num) {
      num = Number(num)
      if (num === 0 || (num > 0 && num < 10000)) {
        return num + '元'
      } else {
        return removeZero((num / 10000).toFixed(4)) + '万'
      }
    }

  }
}
</script>

<style lang="less" scoped>
.content_line1 {
  margin-top: 20px;
  overflow-y: scroll;
  height: calc(100vh - 200px);
  .leftDiv {
    width: 38%;
    margin: 10px 20px;
    background-color: #fff;
    padding: 10px;
    .leftTitle {
      // color:#0079FE;
      font-weight: 800;
      font-size: 14px;
      border-bottom: dashed 1px #e9e9e9;
      // width: 180px;
      padding-bottom: 6px;
    }
    .leftContent {
      margin: 20px;
      li {
        line-height: 24px;
      }
      .li_content {
        color: #000;
        font-weight: 400;
      }
    }
  }
}
.customerDetailsStyle {
  /deep/ .ant-modal {
    padding-bottom: 0;
    box-sizing: border-box;
    .ant-modal-content {
      min-height: calc(100vh);
      background-color: rgb(243, 243, 244);
    }
    .ant-modal-header {
      padding: 10px 20px !important;
    }
  }
}
.projectDetail {
  .information {
    .inform {
      display: flex;
      .titleContent {
        flex: 4;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 10px 20px;
        box-sizing: border-box;
        background-color: #fff;
        .label {
          display: flex;
          align-items: center;
          margin-bottom: 0.5em;
          .labelCOlor {
            color: #666;
          }
          .labelCon {
            margin-bottom: 0;
            .title {
              font-size: 16px;
              font-weight: bold;
              margin-right: 10px;
            }
          }
          &::before {
            content: '';
            display: inline-block;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background-color: #666;
            margin-right: 2px;
          }
        }
      }
      .moneyStyle {
        display: flex;
        padding: 30px 20px 10px;
        box-sizing: border-box;
        background-color: #fff;
        text-align: center;
        .amountNum {
          margin-top: 4px;
          color: #f8ac59;
          .sign {
            font-size: 20px;
            margin-right: 3px;
          }
          .first {
            font-size: 26px;
            font-weight: bold;
          }
          .last {
            font-size: 14px;
          }
        }
      }
      .more {
        flex: 1;
        padding: 10px 20px;
        text-align: right;
        box-sizing: border-box;
        background-color: #fff;
      }
    }
  }
  .messageInfo {
    margin-top: 20px;
    padding: 4px 20px 40px 20px;
    background-color: #fff;
    border: 1px solid #ddd;
  }
  .timeline {
    background-color: #fff;
    padding-bottom: 20px;
    .timeTitle {
      color: #333;
      font-size: 14px;
      font-weight: bold;
      border-bottom: dashed 1px #e9e9e9;
      line-height: 36px;
      padding-left: 20px;
    }
    .tabs {
      padding: 0 20px 20px;
      box-sizing: border-box;
      position: relative;
      .lis {
        width: 100%;
        padding-left: 16px;
        border-bottom: 1px solid #ccc;
        padding-bottom: 10px;
        .lisType {
          display: inline-block;
          background-color: #999;
          color: #fffdfd;
          padding: 2px 6px;
          font-weight: normal;
          text-align: center;
          border-radius: 0.25em;
          margin-bottom: 10px;
        }
        .nameBox {
          font-size: 12px;
          line-height: 2em;
          color: #666;
          .time {
            color: #999;
          }
        }
      }
    }
  }

  .stage {
    padding: 2px 10px;
    border-radius: 6px;
    margin-right: 10px;
    box-sizing: border-box;
    color: #fff;
    &.s1 {
      background-color: #2db7f5;
    }
    &.s2 {
      background-color: #87d068;
    }
    &.s3 {
      background-color: #faad14;
    }
  }
}
/deep/ .ant-tabs-content {
  padding-left: 10px;
}
.tabpane1 {
  padding-left: 20px;
}
.tabpane2 {
  padding-left: 40px;
}
.tabpane3 {
  padding-left: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/customerManage/detail.vue